<template>
  <div class="intelligent">
    <div class="intelligent__title">
      Intelligent Recognition
    </div>
    <div
      class="identify-address"
      :class="{ 'focus': intelligentFocus }"
    >
      <Icon
        v-if="identifyAddress"
        @click="identifyAddress = ''"
        class="clear-btn"
        name="close-l"
      />
      <textarea
        v-model="identifyAddress"
        @focus="intelligentFocus = true"
        @blur="intelligentFocus = false"
        @input="adjustHeight"
        placeholder="{Identify clipboard address} Intelligent splitting of names, phone numbers, and addresses."
      />
      <div
        v-if="!identifyAddress"
        @click="handlePasteAddress"
        class="identify-address-btn"
      >
        Identify Clipboard
      </div>
      <div
        v-else
        class="identify-address-btn identify"
        :class="{ 'identifying': identifying }"
        @click="handleIdentify"
      >
        <div
          v-if="identifying"
          class="loading"
        />
        {{ identifying ? 'Identifying your address' : 'Identify' }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { buriedPointUtil } from '@/utils/utils'
import { fetchData } from '@/utils/fetch'
import { usePlugin } from '@/hooks/usePlugin'
import { Icon } from '@/components/Icon'

const emits = defineEmits(['parseSuccess'])

const props = defineProps({
  addressType: {
    type: Number,
    default: 2
  }
})

const { $toast } = usePlugin()

const identifyAddress = ref('')

const identifying = ref(false)

const intelligentFocus = ref(false)

const adjustHeight = (e) => {
  e.target.style.height = 'auto'
  const height = e.target.scrollHeight
  e.target.style.height = height + 'px'
}

const handlePasteAddress = async () => {
  const text = await navigator.clipboard.readText()
  if (!text.trim()) {
    $toast('There is no available address. Please copy it and try again.')
    return
  }
  identifyAddress.value = text
}

const handleIdentify = async () => {
  buriedPointUtil({ eventId: 'PAE203', others: { addressType: props.addressType } })
  identifying.value = true

  try {
    const { code, data } = await fetchData('/appb/alibaba-inter/addressResolution', {
      method: 'post',
      body: JSON.stringify({
        address: identifyAddress.value
      })
    })

    if (code === 200) {
      emits('parseSuccess', data)
      $toast('Identify successfully')
      identifying.value = false
    }
  } catch (error) {
    identifying.value = false
  }
}
</script>

<style lang='less' scoped>
.intelligent {
  margin-top: 32px;

  &__title {
    color: #232323;
    font-size: 14px;
    font-family: mon-600;
    line-height: 18px;
  }

  .identify-address {
    margin-top: 8px;
    position: relative;
    padding: 12px 16px;
    border: 1px solid var(--main-border-color);
    border-radius: 4px;
    text-align: right;

    &.focus {
      border: var(--focus-border);
    }

    .clear-btn {
      position: absolute;
      top: 12px;
      right: 16px;
      font-size: 16px;
      cursor: pointer;
    }

    textarea {
      color: #5C5C5C;
      font-size: 12px;
      font-family: mon-500;
      outline: none;
      border: none;
      resize: none;
      width: 100%;
      height: 18px;
      line-height: 18px;
      &::placeholder {
        color: #b2b7c2;
        font-size: 12px;
        font-family: mon-500;
      }
    }

    .identify-address-btn {
      margin-top: 16px;
      height: 28px;
      padding: 0 12px;
      border-radius: 24px;
      border: 1px solid #EBF1F5;
      background-color: white;
      color: #232323;
      font-size: 12px;
      font-family: mon-600;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &.identify {
        border-color: #052784;
        color: #052784;
      }

      &.identifying {
        border: none;
        background-color: #14141464;
        color: white;
      }

      .loading {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        margin-right: 6px;
        animation: loading 1s linear infinite;
        border: 1px solid white;
        border-top: 1px solid transparent;

        @keyframes loading {
          0% {
            transform: rotate(0deg);
          }

          100% {
            transform: rotate(360deg);
          }
        }
      }
    }
  }
}
</style>
